export default __webpack_public_path__ + "static/SR USA - Dietary Fiber - Statement-fee67e82d0f339c5021456010f050e89.pdf";